import { viewerApiUrl } from "API/urls/viewer.api";
import { axiosInstance } from "configs/axios";

export const projectTaskStatusViewerApi = async (docType) => {
  try {
    const response = await axiosInstance.post(viewerApiUrl.project, {
      docType,
    });
    return { data: response.data, status: response?.request?.status };
  } catch (error) {
    return {
      data: error?.response?.data || "No data",
      status: error?.response?.request?.status || "No status",
    };
  }
};
